/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import {
  AccountCircle,
  Face as BoyAvatar,
  Face4 as GirlAvatar,
  Logout,
  Menu as MenuIcon,
  MoreVert,
  Notifications,
} from '@mui/icons-material'
import {
  Box,
  Button,
  Chip,
  IconButton,
  AppBar as MuiAppBar,
  AppBarProps as MuiAppBarProps,
  Toolbar,
  Typography,
  styled,
} from '@mui/material'
import i18n from 'i18n'

import { usePOST_authLogoutMutation } from 'redux/api/authApi'
import { useGET_userQuery } from 'redux/api/userAPI'
import { useAppDispatch } from 'redux/hooks'
import { RootState } from 'redux/store'
import {
  resetNavigation,
  setActiveNavItemIndex,
  toggleNavigation,
  toggleNotifications,
} from 'redux/ui/common/themeUI'

import {
  setUser,
} from 'redux/ui/common/userUI'

import PopupMenu from 'components/molecules/PopupMenu'
import SearchBar from 'components/molecules/SearchBar'

import { useMedia } from 'utils/customHooks/useMedia'
import { DRAWER_WIDTH, HEADER_HEIGHT } from 'utils/customizedTheme'

import Logo from 'assets/svg/logo.svg'
import FlagEN from 'assets/svg/en.svg'
import FlagSV from 'assets/svg/sv.svg'
import FlagBG from 'assets/svg/bg.svg'
import FlagPT from 'assets/svg/pt.svg'
import FlagES from 'assets/svg/es.svg'
import FlagSQ from 'assets/svg/sq.svg'

const Header = () => {
  const { t } = useTranslation()
  const { isUnder900px } = useMedia()

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const [POST_authLogout] = usePOST_authLogoutMutation()

  const [userMenuAnchor, setUserMenuAnchor] = useState(null)
  const [langMenuAnchor, setLangMenuAnchor] = useState(null)
  const [mobileMenuAnchor, setMobileMenuAnchor] = useState(null)

  const userToken = window.localStorage.getItem('token')
  const { data: userData, error: userError } = useGET_userQuery(null, { skip: !userToken })
  const openNavigation = useSelector((state: RootState) => state.theme.openNavigation)

  const changeLanguage = (e: any, lng: string) => {
     i18n.changeLanguage(lng)
     //console.log('lng', lng)
     window.localStorage.setItem('language', lng)
     window.location.reload()
   }

  const handleLogout = () => {
    //POST_authLogout()
    window.localStorage.removeItem('layout')
    window.localStorage.removeItem('language')
    window.localStorage.removeItem('token')
    window.localStorage.removeItem('openNavigation')
    window.localStorage.removeItem('openSidebar')
    dispatch({ type: "RESET" })
    navigate('/login')
  }

 

  if (userError) handleLogout()

  return (
    <Box>
      <AppBar position='fixed' open={openNavigation}>
        <Toolbar sx={{ color: 'rgba(0,0,0,0.4)', paddingRight: '0.5rem !important' }}>
          <Box sx={{ width: DRAWER_WIDTH, display: 'flex', alignItems: 'center' }}>
            {/* Nav Button */}
            <IconButton
              // size='large'
              edge='start'
              color='inherit'
              aria-label='open drawer'
              onClick={() => dispatch(toggleNavigation())}
              sx={{ mr: 2 }}
            >
              <MenuIcon sx={{ fontSize: '2.75rem' }} />
            </IconButton>

            {/* EsyBee logo */}
            <Box
              component='img'
              sx={{
                height: '3.7rem',
                width: 'auto',
                marginBottom: '-3px',
                cursor: 'pointer',
              }}
              onClick={() => navigate('/')}
              alt='EsyBee'
              src={Logo}
            />
          </Box>

          {/* Search bar */}
          {!isUnder900px && !['parent','student'].includes(userData?.role) && (
            <Box sx={{ width: '30%' }}>
              <SearchBar border={'#fff'} />
            </Box>
          )}

          {/* Empty element to provide space */}
          <Box sx={{ flexGrow: 1 }} />

          {/* Settings Menu -  Date / User / Notifications / Theme / Language */}
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            {/* User menu button */}
            <Button
              size='large'
              aria-controls={'user-menu-id'}
              aria-haspopup='true'
              onClick={(e) => setUserMenuAnchor(e.currentTarget)}
              color='inherit'
              sx={{ borderRadius: '2rem', paddingLeft: '1rem' }}
            >
              <HeaderText sx={{ marginRight: '0.5rem' }}>
                {userData && `${userData?.first_name} ${userData?.last_name}`}
              </HeaderText>
              <Chip
                icon={
                  userData?.gender === 'male' ? (
                    <BoyAvatar sx={{ color: 'rgba(0,0,0,0.4) !important', fontSize: '2.5rem' }} />
                  ) : (
                    <GirlAvatar
                      sx={{
                        color: 'rgba(0,0,0,0.4) !important',
                        fontSize: '2.5rem',
                        '-webkit-transform': 'scaleX(-1)',
                        transform: 'scaleX(-1)',
                      }}
                    />
                  )
                }
                label={userData ? <span style={{ textTransform: 'capitalize' }}>{ t(`roles.${userData.role}`) }</span> : <></>}
                variant='outlined'
                sx={{ height: '2.8rem', borderRadius: '1.4rem', borderColor: '#000' }}
              />
            </Button>
            {/* Notifications button */}
            <IconButton
              size='large'
              aria-label='show 17 new notifications'
              color='inherit'
              onClick={() => dispatch(toggleNotifications())}
            >
              <Notifications sx={{ fontSize: '2.5rem' }} />
            </IconButton>
            {/* Language menu button */}
            <Flag lang={i18n.language} setLangMenuAnchor={setLangMenuAnchor} />
          </Box>

          {/* Mobile Settings Menu Button */}
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size='large'
              aria-controls={'mobile-menu-id'}
              aria-haspopup='true'
              onClick={(e) => {
                setMobileMenuAnchor(e.currentTarget)
              }}
              color='inherit'
            >
              <MoreVert sx={{ fontSize: '2.75rem' }} />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {/* Mobile menu */}
      <PopupMenu
        id={'mobile-menu-id'}
        anchorEl={mobileMenuAnchor}
        setIsMenuOpen={setMobileMenuAnchor}
        onClose={() => setUserMenuAnchor(null)}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          paddingTop: '0.2rem',
          paddingBottom: '0.2rem',
          minWidth: '11rem',
        }}
        items={[
          {
            text: <Typography>{i18n.language}</Typography>,
            icon: (
              <Flag
                sx={{ padding: '0', size: '1.5rem' }}
                lang={i18n.language}
                setLangMenuAnchor={setLangMenuAnchor}
              />
            ),
            onClick: (e: React.MouseEvent<HTMLElement>) => setLangMenuAnchor(e.currentTarget),
            preventCloseOnClick: true,
            sx: { paddingTop: '0.8rem', paddingBottom: '0.8rem' },
          },
          {
            text: <Typography>{`${t('common.notifications')}`}</Typography>,
            icon: <Notifications color='primary' />,
            onClick: () => dispatch(toggleNotifications()),
            sx: { paddingTop: '0.8rem', paddingBottom: '0.8rem' },
          },
          {
            text: <Typography>{`${t('common.logout')}`}</Typography>,
            icon: <Logout color='primary' />,
            onClick: () => {handleLogout()},
            sx: { paddingTop: '0.8rem', paddingBottom: '0.8rem' },
          },
        ]}
      />
      {/* User menu */}
      <PopupMenu
        id={'user-menu-id'}
        anchorEl={userMenuAnchor}
        setIsMenuOpen={setUserMenuAnchor}
        items={[
          {
            icon: <Logout fontSize='small' />,
            text: `${t('common.logout')}`,
            onClick: handleLogout,
          },
        ]}
        sx={{ minWidth: '12rem' }}
      />
      {/* Language menu */}
      <PopupMenu
        id={'lang-menu-id'}
        anchorEl={langMenuAnchor}
        setIsMenuOpen={setLangMenuAnchor}
        items={[
          {
            text: 'en',
            icon: <Flag lang={'en'} setLangMenuAnchor={setLangMenuAnchor} />,
            onClick: changeLanguage,
            hidden: i18n.language === 'en',
          },
          {
            text: 'es',
            icon: <Flag lang={'es'} setLangMenuAnchor={setLangMenuAnchor} />,
            onClick: changeLanguage,
            hidden: i18n.language === 'es',
          },
          {
            text: 'pt',
            icon: <Flag lang={'pt'} setLangMenuAnchor={setLangMenuAnchor} />,
            onClick: changeLanguage,
            hidden: i18n.language === 'pt',
          },
          {
            text: 'sv',
            icon: <Flag lang={'sv'} setLangMenuAnchor={setLangMenuAnchor} />,
            onClick: changeLanguage,
            hidden: i18n.language === 'sv',
          },  
          {
            text: 'sq',
            icon: <Flag lang={'sq'} setLangMenuAnchor={setLangMenuAnchor} />,
            onClick: changeLanguage,
            hidden: i18n.language === 'sq',
          }, 
          {
            text: 'bg',
            icon: <Flag lang={'bg'} setLangMenuAnchor={setLangMenuAnchor} />,
            onClick: changeLanguage,
            hidden: i18n.language === 'bg',
          },
        ]}
        sx={{ minWidth: '12rem' }}
      />
    </Box>
  )
}

export default Header

interface AppBarProps extends MuiAppBarProps {
  open?: boolean
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  boxShadow: 'none',
  justifyContent: 'center',
  height: `${HEADER_HEIGHT}px`,
}))

interface ITextProps {
  sx?: { [key: string]: string }
  children: string
}

export const HeaderText: FC<ITextProps> = ({ sx, children }) => {
  return (
    <Typography
      sx={{
        display: 'flex',
        alignItems: 'center',
        fontSize: '1.05rem',
        fontWeight: '500',
        ...sx,
      }}
    >
      {children}
    </Typography>
  )
}

interface IFlagProps {
  lang: string
  setLangMenuAnchor: any
  sx?: { [key: string]: string }
}

const Flag: FC<IFlagProps> = ({ lang, setLangMenuAnchor, sx }) => {
  const flag = {
    en: FlagEN,
    sv: FlagSV,
    bg: FlagBG,
    pt: FlagPT,
    es: FlagES,
    sq: FlagSQ,
  }

  return (
    <IconButton
      size='large'
      aria-controls={'lang-menu-id'}
      aria-haspopup='true'
      color='inherit'
      sx={{ padding: sx?.padding }}
      onClick={(e) => setLangMenuAnchor(e.currentTarget)}
    >
      <Box
        sx={{
          position: 'relative',
          borderRadius: '50%',
          overflow: 'hidden',
          height: sx?.size ? sx.size : '2.5rem',
          width: sx?.size ? sx.size : '2.5rem',
        }}
      >
        <Box
          component='img'
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            translate: '-50% -50%',
            height: '100%',
            width: 'auto',
            marginBottom: '-3px',
            cursor: 'pointer',
          }}
          alt='language'
          src={flag[lang]}
        />
      </Box>
    </IconButton>
  )
}
